jQuery( window ).on( "load", function() {

  if(jQuery('.latest-update-list').length) {

    let $grid = jQuery('.latest-update-list').masonry({
      itemSelector: '.card--event-card',
      percentPosition: true
    });

    $grid.imagesLoaded().progress( function() {
      $grid.masonry('layout');
      AOS.refresh();
    });
  }
});
